import { IToken } from '@/types'

export const findTokenByAddressAndChainId = (address: string, chainId: string, listToken: IToken[]): IToken | null => {
  return (
    listToken.find(
      (token) =>
        token.tokenAddress.toLowerCase() === address.toLowerCase() &&
        token.networkId.toLowerCase() === chainId.toLowerCase()
    ) || null
  )
}
